// extracted by mini-css-extract-plugin
module.exports = {"feedContainer":"RssFeed_feedContainer__12LEH","title":"RssFeed_title__2BCQR","feedError":"RssFeed_feedError__1EHOW"};